module.exports = __webpack_public_path__ + "assets/images/AmiraSkillScaffold.dbda15629bb865c66f3dfe78028577ad.svg";